import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import Router from '../common/router';
import ReduxStateDecorator from './redux/StateDecorator';
import i18n from './i18n';
import Analytics from '@alcumus/analytics-package';
import environmentVariables from '../common/environmentVariables';
import { configureBrowserWebApp, } from '@alcumus/browser-web-utils';
import { FeatureToggles } from '../common/constants/featureToggles';
export default async function RenderApp() {
    const supportsHistory = 'pushState' in window.history;
    const RootElement = document.getElementById('root');
    let preloadedState;
    if (typeof window !== 'undefined') {
        // @ts-ignore
        preloadedState = window.__PRELOADED_STATE__ || {};
        const stateData = document.getElementById('stateData');
        if (stateData)
            document.head.removeChild(stateData);
        // @ts-ignore
        delete window.__PRELOADED_STATE__;
    }
    // Todo: remove this await, add an root component that waits for i18n
    await i18n;
    if (FeatureToggles.enableSentry()) {
        const conf = {
            sentry: {
                SENTRY_ENVIRONMENT: environmentVariables.SENTRY_ENVIRONMENT,
                SENTRY_DSN: environmentVariables.SENTRY_DSN,
                SENTRY_SAMPLE_RATE: environmentVariables.SENTRY_SAMPLE_RATE || '1.0',
                SENTRY_RELEASE: environmentVariables.SENTRY_RELEASE,
            },
        };
        configureBrowserWebApp(conf);
    }
    Analytics.getInstance().initialize(preloadedState.mixpanelToken);
    ReactDOM.hydrate(React.createElement(BrowserRouter, { forceRefresh: !supportsHistory },
        React.createElement(ReduxStateDecorator, { initialState: preloadedState },
            React.createElement(Router, null))), RootElement);
}
